import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PopupModal from '@/components/common/Modal/PopupModal.vue'
import { mapGetters } from 'vuex'
import * as types from '@mail/store/types'
import FolderList from './FolderList.vue'
import ModalMask from '@/components/common/Modal/ModalMask.vue'
import Modal from '@/components/common/Modal/Modal.vue'
import api from '@mail/api'
@Component({
    components: { PopupModal, FolderList, ModalMask, Modal },
    computed: {
        ...mapGetters({
            currentEmail: types.EMAIL_CURRENT,
            selectList: types.EMAIL_SELECT
        }),
    },
})
export default class MoveModal extends Vue {

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    
    @Prop({ type: Boolean }) showMove!: boolean
    @Prop({ type: Boolean }) redirect!: boolean
    

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    
    currentEmail!: mail.EmailMessage
    selectList!: string[]

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    select(folder: mail.MailboxFolder) {
        const route = this.$route.name
        //const ids = [this.currentEmail.id]
        const ids = route == 'mail-read' ? [this.currentEmail.id] : this.selectList

        if (route == 'mail-read') {
            api.mail.moveEmails(ids, folder.id).then((succeed) => {
                if (succeed) {
                    this.currentEmail.deleted = true
                } else {
                    this.currentEmail.deleted = false
                }
            }).catch(() => {
                this.currentEmail.deleted = false
            })
            this.$emit('close')
        } else {
            this.$emit('moveItems', folder.id)
        }
    }
}
